import { loadable } from "components/SpruceLoader";

export const Image = loadable(() => import("./image/index"));
